import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Input, Radio, RadioOption } from '@node-space/ui-components'

interface ExpirySelectProps {
  options: RadioOption[]
  onValueChange: (value: ExpiryIntervalInterface) => void
  errorText?: string
}

interface ExpiryIntervalInterface {
  expiryAmount: number
  expiryType: string
}

const expiryAmountConvertor: { [index: string]: number } = {
  days: 1 / (60 * 24),
  minutes: 60 * 24,
}

export const ExpirySelect = React.forwardRef(
  ({ options, onValueChange, errorText }: ExpirySelectProps, ref: React.MutableRefObject<null>) => {
    const { t } = useTranslation()
    const [expiryInterval, setExpiryInterval] = useState<ExpiryIntervalInterface>({
      expiryAmount: 2,
      expiryType: 'days',
    })

    useEffect(() => {
      if (onValueChange) {
        onValueChange(expiryInterval)
      }
    }, [expiryInterval])

    return (
      <Box flex gapX={8} className="align-baseline">
        <Box className="max-w-[155px]">
          <Input
            ref={ref}
            inputMode="numeric"
            name="expiryAmount"
            errorText={errorText}
            label={t('payments.paymentLinks.expiryTime')}
            onChange={e => {
              setExpiryInterval({
                ...expiryInterval,
                expiryAmount: Number(e.target.value),
              })
            }}
            value={expiryInterval.expiryAmount.toString()}
            testId="expiry-minutes"
          />
        </Box>

        <Radio
          name="expiry-time"
          horizontal
          // Invisiable lable, to align the radio button with the input
          label="‎ "
          border={false}
          options={options}
          value={expiryInterval.expiryType}
          onChange={value => {
            const expiryTime = Number(expiryInterval.expiryAmount) * expiryAmountConvertor[value]

            if (value != expiryInterval.expiryType) {
              setExpiryInterval({
                ...expiryInterval,
                expiryAmount: expiryTime,
                expiryType: value,
              })
            }
          }}
        />
      </Box>
    )
  }
)
